/* Prime Outlet · Zoom de imagen al pasar el mouse (estilo Mercado Libre)
   Solo escritorio con mouse (>=990px). Muestra una lupa sobre la imagen y
   un panel ampliado encima de la columna de informacion. El clic sigue
   abriendo la imagen completa (lightbox). */
(function () {
  if (window.__poZoom) return;
  window.__poZoom = true;

  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var ZOOM = 2.5;
  var SEL = '[id^="GalleryViewer"] .product-media-container.media-type-image';

  var lens = null, panel = null, current = null, hiSrc = '';

  function ensureEls() {
    if (panel) return;
    lens = document.createElement('div');
    lens.className = 'po-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    panel = document.createElement('div');
    panel.className = 'po-zoom-panel';
    panel.setAttribute('aria-hidden', 'true');
    document.body.appendChild(panel);
  }

  function hiRes(img) {
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$12048');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
  }

  function drawnRect(img, box) {
    var nw = img.naturalWidth || box.width, nh = img.naturalHeight || box.height;
    var fit = getComputedStyle(img).objectFit;
    var bw = box.width, bh = box.height, w = bw, h = bh;
    if (fit === 'contain' || fit === 'scale-down') {
      var s = Math.min(bw / nw, bh / nh); w = nw * s; h = nh * s;
    } else if (fit === 'cover') {
      var c = Math.max(bw / nw, bh / nh); w = nw * c; h = nh * c;
    }
    return { x: (bw - w) / 2, y: (bh - h) / 2, w: w, h: h };
  }

  function hide() {
    if (lens) lens.classList.remove('is-on');
    if (panel) panel.classList.remove('is-on');
    if (current) current.classList.remove('po-zoom-active');
    current = null;
  }

  function move(e) {
    var cont = current;
    var img = cont && cont.querySelector('.product__media img');
    if (!img) return hide();
    var box = img.getBoundingClientRect();
    var info = document.querySelector('.product__info-wrapper');
    if (!info || box.width < 50) return hide();
    var infoR = info.getBoundingClientRect();

    var gap = 16;
    var pTop = Math.max(box.top, 12);
    var pH = Math.min(box.height, window.innerHeight - pTop - 12);
    var pW = Math.min(infoR.width, window.innerWidth - box.right - gap * 2);
    if (pW < 240 || pH < 200) return hide();
    panel.style.left = (box.right + gap) + 'px';
    panel.style.top = pTop + 'px';
    panel.style.width = pW + 'px';
    panel.style.height = pH + 'px';

    var d = drawnRect(img, box);
    var lw = Math.min(pW / ZOOM, d.w, box.width);
    var lh = Math.min(pH / ZOOM, d.h, box.height);
    var mx = e.clientX - box.left, my = e.clientY - box.top;
    var minX = Math.max(0, d.x), maxX = Math.min(box.width, d.x + d.w) - lw;
    var minY = Math.max(0, d.y), maxY = Math.min(box.height, d.y + d.h) - lh;
    var lx = Math.min(Math.max(mx - lw / 2, minX), Math.max(minX, maxX));
    var ly = Math.min(Math.max(my - lh / 2, minY), Math.max(minY, maxY));

    if (lens.parentNode !== img.parentNode) img.parentNode.appendChild(lens);
    var off = img.parentNode.getBoundingClientRect();
    lens.style.width = lw + 'px';
    lens.style.height = lh + 'px';
    lens.style.left = (box.left - off.left + lx) + 'px';
    lens.style.top = (box.top - off.top + ly) + 'px';

    var zx = pW / lw, zy = pH / lh;
    panel.style.backgroundSize = (d.w * zx) + 'px ' + (d.h * zy) + 'px';
    panel.style.backgroundPosition = (-(lx - d.x) * zx) + 'px ' + (-(ly - d.y) * zy) + 'px';

    lens.classList.add('is-on');
    panel.classList.add('is-on');
  }

  document.addEventListener('mousemove', function (e) {
    if (!mq.matches) { if (current) hide(); return; }
    var cont = e.target.closest ? e.target.closest(SEL) : null;
    if (!cont) { if (current) hide(); return; }
    ensureEls();
    if (cont !== current) {
      hide();
      current = cont;
      cont.classList.add('po-zoom-active');
      var img = cont.querySelector('.product__media img');
      var src = img ? hiRes(img) : '';
      if (src && src !== hiSrc) {
        hiSrc = src;
        panel.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      }
    }
    move(e);
  }, { passive: true });

  document.addEventListener('mouseleave', hide);
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(SEL)) hide();
  }, true);
})();
